<template lang="pug">
.campaign-info(v-loading="loading")
  title-bar(style="justify-content: space-between") {{ $t('项目信息') }}
    el-button.btn_restart(
      v-if="campaignInfo.status === 4 && isCreator"
      type="primary"
      @click="restartProject"
    ) {{ $t('重启项目') }}
  .info-display
    campaign-info-display(
      :campaignInfo="campaignInfo"
    )
  .section-divider
  title-bar {{ $t('Brief') }}
  .info-display(v-if="campaignInfo.brief")
    el-row(:gutter="20").row-content
      el-col(:span="24")
        .info_label {{ $t('附件') }}
        .info_content
          a(
            :href="campaignInfo.brief.file_download_path"
            target="_blank"
          ) {{ campaignInfo.brief.file_name }}
    el-row.row-content(:gutter="20")
      el-col(:span="24")
        .info_label {{ $t('期望权益') }}
        .info_content {{ campaignInfo.brief.remark ? campaignInfo.brief.remark : '—' }}
  .section-divider(v-if="approveHistory.length")
  template(v-if="approveHistory.length")
    title-bar {{ $t('历史记录') }}
    audit-versions-item(
      v-for="(item, idx) in approveHistory"
      :item="item"
      :key="idx"
      :auditType="item.audit_type"
    )
</template>

<script>
import FooterButton from '@/components/FooterButton'
import axios from 'axios'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import TitleBar from '@/components/TitleBar'
import AuditVersionsItem from '../components/AuditVersionsItem'
import CampaignInfoDisplay from '../components/CampaignInfoDisplay'
export default {
  components: {
    AuditVersionsItem,
    FooterButton,
    UploadedFileDisplay,
    TitleBar,
    CampaignInfoDisplay
  },
  data () {
    return {
      loading: false,
      approveHistory: []
    }
  },
  computed: {
    campaignInfo () {
      return this.$store.state.unistar.campaignInfo
    },
    isCreator () {
      return this.$store.state.common.user.user_id === this.campaignInfo.brief.user_id
    },
    sowInfo () {
      return this.$store.state.unistar.sowInfo
    },
    currentTask () {
      return this.$store.state.unistar.sowProcess.find(task => this.$route.path.includes(task.action))
    }
  },
  async mounted () {
    this.loading = true
    await this.$store.dispatch('unistar/getCampaignInfo')
    await this.$store.dispatch('unistar/getProcessTasks', {
      business_key: this.campaignInfo.campaign_id,
      business_type: this.sowInfo.business_type,
      phase_type: 1
    })
    if (this.sowInfo.business_type) {
      this.getApproveHistory()
    }
    this.loading = false
  },
  methods: {
    restartProject () {
      this.$router.push('/unistar/new-unistar-campaign?campaignId=' + this.campaignInfo.campaign_id + '&taskId=' + this.currentTask.taskId + '&status=1')
    },
    getApproveHistory () {
      axios.get('/management/subfinal/getApproveHistory', {
        params: {
          id: this.campaignInfo.campaign_id,
          business_type: this.sowInfo.business_type,
          audit_type: 42
        }
      }).then(res => {
        this.approveHistory = res
      })
    }
  }
}
</script>

<style lang="stylus">
.footer-button
  padding-left 0

.campaign-info
  .category
    padding 0
  .uploaded-file-display
    > span
        width auto !important

.campaign-info__dialog
  .el-dialog
    width 800px
    .el-dialog__body
      > p
        text-align center

.campaign-info__autocomplete
  width 400px !important
.input-error
  padding 0 10px
</style>
